






































import { InstrumentStatus, SelectedInstrument } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _, { Dictionary } from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GenericLoadingSpinner,
    InstrumentName,
  }
})
export default class GroupedInstrumentsTable extends Vue {
  @Prop({ required: true })
  detailItems: Dictionary<any[]>;

  @Prop({ required: true })
  showBusyState: boolean;
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  isDisabled (instrumentDetail: SelectedInstrument): boolean {
    return !this.drivewealthSweepStore.isActive
        || this.drivewealthSweepStore.isAlreadySelected(instrumentDetail.stockSymbol)
        || instrumentDetail.status !== InstrumentStatus.Active;
  }

  getInstrumentListAssetCategory (instrumentList: any[]): string {
    if (!instrumentList || !instrumentList.length) {
      return "";
    }

    const instrument = _.head(instrumentList);

    return instrument.assetCategoryName;
  }

  getInstrumentListHeading (instrumentList: any[]): string {
    if (!instrumentList || !instrumentList.length) {
      return "";
    }

    const instrument = _.head(instrumentList);

    if (!instrument.assetCategoryName && !instrument.allocationPercentage) {
      return "";
    }

    return `${instrument.assetCategoryName} - ${instrument.allocationPercentage}%`;
  }

  isInstrumentListOtherCategory (instrumentList: any[]): boolean {
    if (!instrumentList || !instrumentList.length) {
      return false;
    }

    const instrument = _.head(instrumentList);

    if (instrument.assetCategoryName && instrument.allocationPercentage === 0) {
      return true;
    }

    return false;
  }

  detailFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2 col-md-6 col-6",
      tdClass: "pl-2 col-md-6 col-6",
      label: "Investment"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center col-md-3 d-md-table-cell d-none",
      tdClass: "text-center col-md-3 d-md-table-cell d-none"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center col-md-3 col-6",
      tdClass: "col-md-3 col-6"
    },
  ];
}
